export default __webpack_public_path__ + "static/media/p.1bb13c6b.jpg";